module.exports = __webpack_public_path__ + "img/kejie.82d1444f.png";